export default __webpack_public_path__ + "static/media/select_country.54184498.svg";